import {toolbarGoBack} from './toolbarGoBack.directive';
import {toolbarClose} from './toolbarClose.directive';
import {toolbarMenu} from './toolbarMenu.directive';
import './toolbar.css';

let appModule = angular.module('deliveryCreate.app');

appModule.directive('toolbarGoBack', toolbarGoBack);
appModule.directive('toolbarClose', toolbarClose);
appModule.directive('toolbarMenu', toolbarMenu);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/bootstrap.ts
 **/